import DialogPrepayReturn from "./DialogPrepayReturn";

export default {
    name     : 'dialog_prepay_return',
    component: DialogPrepayReturn,
    dialog   : {
        'max-width': "500px",
        'persistent': true
    }
}
